/*
 ** vue router: NameCard
 */
import type { RouteRecordRaw } from 'vue-router';

const vrtNameCard: RouteRecordRaw = {
  path: '/eservices/namecard',
  name: 'vrtNameCard',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'create',
      name: 'vrtNameCardOperate',
      component: () => import('./vpgNameCardOperate.vue'),
    },
    {
      path: 'view',
      name: 'vrtNameCardView',
      component: () => import('./vpgNameCardView.vue'),
    },
    {
      path: 'search',
      name: 'vrtNameCardList',
      component: () => import('./vpgNameCardList.vue'),
    },
  ],
};

export default vrtNameCard;
